import styled from "styled-components";
export default styled.div`
font-size: 1.05rem;
  color: ${({ theme }) => theme.colors.dark};
  background-color: ${({ theme }) => theme.colors.extralight};
  border-radius: ${({borderRadius}) => borderRadius ? borderRadius : 0};
  padding: 0.65rem 1rem;
  font-weight: 700;
`;
